export default __webpack_public_path__ + "static/876-cb7c919b18d056923494042fd5525ae9.gif";